(function () {
  "use strict";

  var form = document.getElementById("juici-shipping-form");
  if (!form) return;

  var alertEl = document.getElementById("juici-shipping-alert");
  var submitBtn = document.getElementById("juici-shipping-submit");
  var apiUrl = (form.dataset.apiUrl || "").trim();
  var pickupSelect = document.getElementById("pickup_time");
  var pickupDateSelect = document.getElementById("pickup_date");
  var summaryPickup = document.getElementById("juici-summary-pickup");
  var summaryPickupValue = document.getElementById("juici-summary-pickup-value");
  var summaryDeliveryFee = document.getElementById("juici-summary-delivery-fee");
  var summaryDeliveryFeeValue = document.getElementById("juici-summary-delivery-fee-value");
  var summaryTotalValue = document.getElementById("juici-summary-total-value");
  var summaryMinNote = document.getElementById("juici-summary-min-note");
  var pickupFieldset = document.getElementById("pickup-fieldset");
  var deliveryRulesHint = document.getElementById("delivery-rules-hint");
  var termsCheckbox = document.getElementById("accept_terms");

  var DELIVERY_MIN_CENTS = Math.round(Number(form.dataset.deliveryMin || 175) * 100);
  var DELIVERY_FEE_CENTS = Math.round(Number(form.dataset.deliveryFee || 17.63) * 100);
  var DELIVERY_FREE_FROM_CENTS = Math.round(
    Number(form.dataset.deliveryFreeFrom || 199) * 100
  );
  var CART_SUBTOTAL_CENTS = Number(form.dataset.subtotalCents || 0);

  var BARBADOS_PARISHES = [
    "Christ Church",
    "Saint Andrew",
    "Saint George",
    "Saint James",
    "Saint John",
    "Saint Joseph",
    "Saint Lucy",
    "Saint Michael",
    "Saint Peter",
    "Saint Philip",
    "Saint Thomas",
  ];

  var fields = {
    first_name: {
      required: true,
      label: "First name",
      minLength: 2,
      maxLength: 50,
      pattern: /^[a-zA-Z\u00C0-\u024F\s'-]+$/,
      patternMsg: "First name can only contain letters, spaces, hyphens, and apostrophes",
    },
    last_name: {
      required: true,
      label: "Last name",
      minLength: 2,
      maxLength: 50,
      pattern: /^[a-zA-Z\u00C0-\u024F\s'-]+$/,
      patternMsg: "Last name can only contain letters, spaces, hyphens, and apostrophes",
    },
    address: {
      required: true,
      label: "Address",
      minLength: 5,
      maxLength: 120,
    },
    city: {
      required: true,
      label: "City",
      minLength: 2,
      maxLength: 60,
      pattern: /^[a-zA-Z\u00C0-\u024F\s'.-]+$/,
      patternMsg: "Enter a valid city name",
    },
    state: {
      required: true,
      label: "Parish",
    },
    country: {
      required: true,
      label: "Country",
    },
    zip: {
      required: true,
      label: "Postal code",
      type: "zip",
    },
    phone: {
      required: true,
      label: "Phone",
      type: "phone",
    },
    email: {
      required: true,
      label: "Email",
      type: "email",
      maxLength: 254,
    },
  };

  function showAlert(message) {
    if (!alertEl) return;
    alertEl.textContent = message;
    alertEl.classList.add("juici-shipping__alert--visible");
    alertEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function hideAlert() {
    if (!alertEl) return;
    alertEl.classList.remove("juici-shipping__alert--visible");
  }

  function setFieldError(name, message) {
    var input = form.querySelector('[name="' + name + '"]');
    var errorEl = document.getElementById("error-" + name);
    if (input) {
      input.classList.toggle("juici-shipping__input--error", !!message);
      input.classList.toggle("juici-shipping__select--error", !!message);
      input.setAttribute("aria-invalid", message ? "true" : "false");
    }
    if (errorEl) errorEl.textContent = message || "";
  }

  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function normalizePhone(phone) {
    var digits = String(phone || "").replace(/\D/g, "");
    if (!digits) return null;

    // Already includes Barbados country code
    if (digits.indexOf("1246") === 0 && digits.length === 11) {
      return "+" + digits;
    }

    // Local Barbados 7-digit number
    if (digits.length === 7) {
      return "+1246" + digits;
    }

    // 246 + 7 digits
    if (digits.indexOf("246") === 0 && digits.length === 10) {
      return "+1" + digits;
    }

    // Generic international with country code
    if (digits.length >= 10 && digits.length <= 15) {
      return "+" + digits;
    }

    return null;
  }

  function validatePhone(value) {
    if (!value || !value.trim()) {
      return { valid: false, message: "Phone is required" };
    }
    var normalized = normalizePhone(value);
    if (!normalized) {
      return {
        valid: false,
        message: "Enter a valid Barbados phone (e.g. 246-555-1234)",
      };
    }
    return { valid: true, normalized: normalized };
  }

  function validateZip(value) {
    var cleaned = String(value || "").trim();
    if (!cleaned) return { valid: false, message: "Postal code is required" };
    if (/^n\/?a$/i.test(cleaned)) return { valid: true, value: "N/A" };
    if (/^[A-Za-z]{2}\d{5}$/.test(cleaned) || /^\d{5}$/.test(cleaned)) {
      return { valid: true, value: cleaned.toUpperCase() };
    }
    if (cleaned.length >= 2 && cleaned.length <= 12) {
      return { valid: true, value: cleaned };
    }
    return { valid: false, message: "Enter a valid postal code or N/A" };
  }

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function getFulfillmentType() {
    var selected = form.querySelector('input[name="fulfillment_type"]:checked');
    return selected && selected.value === "delivery" ? "delivery" : "pickup";
  }

  function moneyFromCents(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function getDeliveryFeeCents(subtotalCents) {
    if (subtotalCents < DELIVERY_FREE_FROM_CENTS) return DELIVERY_FEE_CENTS;
    return 0;
  }

  function getPayableCents(fulfillment, subtotalCents) {
    if (fulfillment === "delivery") {
      return subtotalCents + getDeliveryFeeCents(subtotalCents);
    }
    return subtotalCents;
  }

  function syncFulfillmentUI() {
    var fulfillment = getFulfillmentType();
    var isDelivery = fulfillment === "delivery";

    if (pickupFieldset) pickupFieldset.hidden = isDelivery;
    if (deliveryRulesHint) deliveryRulesHint.hidden = !isDelivery;

    if (pickupDateSelect) {
      pickupDateSelect.required = !isDelivery;
      pickupDateSelect.disabled = isDelivery;
    }
    if (pickupSelect) {
      pickupSelect.required = !isDelivery;
      pickupSelect.disabled = isDelivery;
    }

    updateOrderSummary();
  }

  function updateOrderSummary() {
    var fulfillment = getFulfillmentType();
    var subtotal = CART_SUBTOTAL_CENTS;
    var fee = fulfillment === "delivery" ? getDeliveryFeeCents(subtotal) : 0;
    var total = getPayableCents(fulfillment, subtotal);

    if (summaryDeliveryFee && summaryDeliveryFeeValue) {
      if (fulfillment === "delivery") {
        summaryDeliveryFee.hidden = false;
        summaryDeliveryFeeValue.textContent =
          fee === 0 ? "FREE" : moneyFromCents(fee);
      } else {
        summaryDeliveryFee.hidden = true;
      }
    }

    if (summaryTotalValue) {
      summaryTotalValue.textContent = moneyFromCents(total);
    }

    if (summaryMinNote) {
      if (fulfillment === "delivery" && subtotal < DELIVERY_MIN_CENTS) {
        summaryMinNote.hidden = false;
        summaryMinNote.textContent =
          "Delivery requires a minimum subtotal of " +
          moneyFromCents(DELIVERY_MIN_CENTS) +
          ". Add more items to continue.";
      } else {
        summaryMinNote.hidden = true;
        summaryMinNote.textContent = "";
      }
    }

    updateSummaryPickup();
  }

  function minutesToLabel(totalMinutes) {
    var hours24 = Math.floor(totalMinutes / 60);
    var mins = totalMinutes % 60;
    var suffix = hours24 >= 12 ? "PM" : "AM";
    var hours12 = hours24 % 12;
    if (hours12 === 0) hours12 = 12;
    return hours12 + ":" + pad2(mins) + " " + suffix;
  }

  function minutesToValue(totalMinutes) {
    var hours24 = Math.floor(totalMinutes / 60);
    var mins = totalMinutes % 60;
    return pad2(hours24) + ":" + pad2(mins);
  }

  function getBarbadosNowParts() {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Barbados",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());

    var map = {};
    parts.forEach(function (p) {
      if (p.type !== "literal") map[p.type] = p.value;
    });

    var hour = Number(map.hour === "24" ? "0" : map.hour);
    return {
      date: map.year + "-" + map.month + "-" + map.day,
      minutes: hour * 60 + Number(map.minute),
    };
  }

  function addDaysToIsoDate(isoDate, days) {
    var pieces = isoDate.split("-");
    var utc = Date.UTC(Number(pieces[0]), Number(pieces[1]) - 1, Number(pieces[2]));
    var next = new Date(utc + days * 24 * 60 * 60 * 1000);
    return (
      next.getUTCFullYear() +
      "-" +
      pad2(next.getUTCMonth() + 1) +
      "-" +
      pad2(next.getUTCDate())
    );
  }

  function formatDateLabel(isoDate, todayIso) {
    var pieces = isoDate.split("-");
    var utc = Date.UTC(Number(pieces[0]), Number(pieces[1]) - 1, Number(pieces[2]));
    var label = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    }).format(new Date(utc));

    if (isoDate === todayIso) return "Today — " + label;
    if (isoDate === addDaysToIsoDate(todayIso, 1)) return "Tomorrow — " + label;
    return label;
  }

  function buildPickupDates() {
    if (!pickupDateSelect) return;

    var daysAhead = Number(pickupDateSelect.dataset.daysAhead || 7);
    if (daysAhead < 1) daysAhead = 1;

    var now = getBarbadosNowParts();
    var previous = pickupDateSelect.value;

    pickupDateSelect.innerHTML = "";
    var placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "Select a date";
    pickupDateSelect.appendChild(placeholder);

    for (var i = 0; i < daysAhead; i += 1) {
      var iso = addDaysToIsoDate(now.date, i);
      var option = document.createElement("option");
      option.value = iso;
      option.textContent = formatDateLabel(iso, now.date);
      pickupDateSelect.appendChild(option);
    }

    if (previous && pickupDateSelect.querySelector('option[value="' + previous + '"]')) {
      pickupDateSelect.value = previous;
    } else {
      pickupDateSelect.value = now.date;
    }
  }

  function getLeadMinutes() {
    if (!pickupSelect) return 0;
    var lead = Number(pickupSelect.dataset.leadMinutes || 0);
    return Number.isFinite(lead) && lead > 0 ? lead : 0;
  }

  function isSlotUnavailable(slotMinutes, now, isToday) {
    if (!isToday) return false;
    // Slot must start after now + lead time (e.g. at 10:17, 10:15 is gone).
    return slotMinutes <= now.minutes + getLeadMinutes();
  }

  function buildPickupSlots() {
    if (!pickupSelect) return;

    var start = Number(pickupSelect.dataset.start || 450);
    var end = Number(pickupSelect.dataset.end || 885);
    var interval = Number(pickupSelect.dataset.interval || 15);
    var now = getBarbadosNowParts();
    var selectedDate = pickupDateSelect ? pickupDateSelect.value : now.date;
    var isToday = selectedDate === now.date;
    var previous = pickupSelect.value;

    pickupSelect.innerHTML = "";
    var placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "Select a pickup time";
    pickupSelect.appendChild(placeholder);

    if (!selectedDate) return;

    var available = 0;
    for (var m = start; m <= end; m += interval) {
      var option = document.createElement("option");
      option.value = minutesToValue(m);
      var label = minutesToLabel(m);
      var unavailable = isSlotUnavailable(m, now, isToday);

      if (unavailable) {
        option.disabled = true;
        option.textContent = label + " (passed)";
      } else {
        option.textContent = label;
        available += 1;
      }

      pickupSelect.appendChild(option);
    }

    if (available === 0) {
      var closed = document.createElement("option");
      closed.value = "";
      closed.disabled = true;
      closed.textContent = isToday
        ? "No remaining slots today — pick another date"
        : "No slots available";
      pickupSelect.appendChild(closed);
    }

    if (
      previous &&
      pickupSelect.querySelector('option[value="' + previous + '"]:not([disabled])')
    ) {
      pickupSelect.value = previous;
    } else {
      if (previous) {
        setFieldError(
          "pickup_time",
          "That pickup time is no longer available. Choose another."
        );
      }
      pickupSelect.value = "";
    }

    updateSummaryPickup();
  }

  function refreshPickupAvailability() {
    var previousDate = pickupDateSelect ? pickupDateSelect.value : "";
    buildPickupDates();
    if (previousDate && pickupDateSelect) {
      if (pickupDateSelect.querySelector('option[value="' + previousDate + '"]')) {
        pickupDateSelect.value = previousDate;
      }
    }
    buildPickupSlots();
  }

  function formatPickupDisplay(dateValue, timeValue) {
    if (!dateValue || !timeValue) return "";
    var now = getBarbadosNowParts();
    var dateLabel = formatDateLabel(dateValue, now.date);
    var parts = timeValue.split(":");
    var minutes = Number(parts[0]) * 60 + Number(parts[1]);
    return dateLabel + " · " + minutesToLabel(minutes);
  }

  function updateSummaryPickup() {
    if (!summaryPickup || !summaryPickupValue) return;

    if (getFulfillmentType() === "delivery") {
      summaryPickup.hidden = true;
      return;
    }

    var dateValue = pickupDateSelect ? pickupDateSelect.value : "";
    var timeValue = pickupSelect ? pickupSelect.value : "";
    var label = formatPickupDisplay(dateValue, timeValue);

    if (!label) {
      summaryPickup.hidden = true;
      return;
    }

    summaryPickup.hidden = false;
    summaryPickupValue.textContent = label;
  }

  function validatePickup() {
    setFieldError("pickup_date", "");
    setFieldError("pickup_time", "");
    setFieldError("fulfillment_type", "");

    if (getFulfillmentType() === "delivery") {
      if (CART_SUBTOTAL_CENTS < DELIVERY_MIN_CENTS) {
        setFieldError(
          "fulfillment_type",
          "Delivery requires a minimum order of " +
            moneyFromCents(DELIVERY_MIN_CENTS)
        );
        return false;
      }
      return true;
    }

    var dateValue = pickupDateSelect ? pickupDateSelect.value : "";
    var timeValue = pickupSelect ? pickupSelect.value : "";
    var now = getBarbadosNowParts();

    if (!dateValue) {
      setFieldError("pickup_date", "Select a pickup date");
      return false;
    }

    if (dateValue < now.date) {
      setFieldError("pickup_date", "Pickup date cannot be in the past");
      return false;
    }

    if (!timeValue) {
      setFieldError("pickup_time", "Select a pickup time");
      return false;
    }

    if (dateValue === now.date) {
      var parts = timeValue.split(":");
      var selectedMinutes = Number(parts[0]) * 60 + Number(parts[1]);
      if (isSlotUnavailable(selectedMinutes, now, true)) {
        setFieldError(
          "pickup_time",
          "That pickup time has already passed. Choose another."
        );
        return false;
      }
    }

    return true;
  }

  function validateTerms() {
    setFieldError("accept_terms", "");
    if (!termsCheckbox || !termsCheckbox.checked) {
      setFieldError("accept_terms", "You must accept the Terms of Use to continue");
      return false;
    }
    return true;
  }

  function validateField(name) {
    var config = fields[name];
    if (!config) return "";

    var input = form.querySelector('[name="' + name + '"]');
    var value = input ? input.value.trim() : "";

    if (config.required && !value) return config.label + " is required";
    if (!value) return "";

    if (name === "state" && BARBADOS_PARISHES.indexOf(value) === -1) {
      return "Select a valid parish";
    }

    if (config.minLength && value.length < config.minLength) {
      return config.label + " must be at least " + config.minLength + " characters";
    }
    if (config.maxLength && value.length > config.maxLength) {
      return config.label + " must be " + config.maxLength + " characters or fewer";
    }
    if (config.pattern && !config.pattern.test(value)) {
      return config.patternMsg || "Invalid " + config.label.toLowerCase();
    }
    if (config.type === "email" && !validateEmail(value)) {
      return "Enter a valid email address";
    }
    if (config.type === "phone") {
      var phoneResult = validatePhone(value);
      if (!phoneResult.valid) return phoneResult.message;
    }
    if (config.type === "zip") {
      var zipResult = validateZip(value);
      if (!zipResult.valid) return zipResult.message;
    }

    return "";
  }

  function validateForm() {
    hideAlert();
    var valid = true;

    Object.keys(fields).forEach(function (name) {
      var error = validateField(name);
      setFieldError(name, error);
      if (error) valid = false;
    });

    if (!validatePickup()) valid = false;
    if (!validateTerms()) valid = false;

    if (!valid) {
      var firstInvalid = form.querySelector('[aria-invalid="true"]');
      if (firstInvalid && typeof firstInvalid.focus === "function") {
        firstInvalid.focus();
      }
    }

    return valid;
  }

  function generateReference() {
    return "JUICI-" + Math.random().toString(36).substring(2, 9).toUpperCase();
  }

  function getFormData() {
    var data = {};

    Object.keys(fields).forEach(function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      data[name] = input ? input.value.trim() : "";
    });

    var phoneResult = validatePhone(data.phone);
    if (phoneResult.valid) data.phone = phoneResult.normalized;

    var zipResult = validateZip(data.zip);
    if (zipResult.valid) data.zip = zipResult.value;

    data.country = "BB";
    data.fulfillment_type = getFulfillmentType();

    if (data.fulfillment_type === "delivery") {
      data.pickup_option = "delivery";
      data.pickup_date = "";
      data.pickup_time = "";
      data.pickup_label = "Local Barbados Delivery";
      data.delivery_fee_cents = getDeliveryFeeCents(CART_SUBTOTAL_CENTS);
      data.subtotal_cents = CART_SUBTOTAL_CENTS;
    } else {
      data.pickup_option = "scheduled";
      data.pickup_date = pickupDateSelect ? pickupDateSelect.value : "";
      data.pickup_time = pickupSelect ? pickupSelect.value : "";
      data.pickup_label = formatPickupDisplay(data.pickup_date, data.pickup_time);
      data.delivery_fee_cents = 0;
      data.subtotal_cents = CART_SUBTOTAL_CENTS;
    }

    return data;
  }

  function buildCartAttributes(data, reference) {
    return {
      shipping_first_name: data.first_name,
      shipping_last_name: data.last_name,
      shipping_address: data.address,
      shipping_city: data.city,
      shipping_state: data.state,
      shipping_country: data.country,
      shipping_zip: data.zip,
      shipping_phone: data.phone,
      shipping_email: data.email,
      pickup_option: data.pickup_option,
      pickup_date: data.pickup_date,
      pickup_time: data.pickup_time,
      pickup_label: data.pickup_label,
      payment_reference: reference,
    };
  }

  function updateCartAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attributes }),
      credentials: "same-origin",
    }).then(function (res) {
      if (!res.ok) throw new Error("Could not save shipping info to cart");
      return res.json();
    });
  }

  function getCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    }).then(function (res) {
      if (!res.ok) throw new Error("Could not load cart");
      return res.json();
    });
  }

  function mapCartItems(cart) {
    return cart.items.map(function (item) {
      return {
        variant_id: item.variant_id,
        product_id: item.product_id,
        title: item.product_title,
        quantity: item.quantity,
        price: item.final_price,
        sku: item.sku || undefined,
      };
    });
  }

  function formatApiError(data, status) {
    if (!data) return "Could not start payment (HTTP " + status + ")";
    if (typeof data.error === "string") {
      if (data.details && data.details.fieldErrors) {
        var parts = [];
        Object.keys(data.details.fieldErrors).forEach(function (key) {
          var msgs = data.details.fieldErrors[key];
          if (msgs && msgs.length) parts.push(msgs[0]);
        });
        if (parts.length) return parts[0];
      }
      return data.error;
    }
    return "Could not start payment";
  }

  function createPayment(cart, shipping, reference) {
    if (!apiUrl) {
      throw new Error("Checkout API URL is not configured in theme settings.");
    }

    var subtotal = Number(cart.total_price || 0);
    CART_SUBTOTAL_CENTS = subtotal;
    var total = getPayableCents(shipping.fulfillment_type, subtotal);
    shipping.subtotal_cents = subtotal;
    shipping.delivery_fee_cents =
      shipping.fulfillment_type === "delivery"
        ? getDeliveryFeeCents(subtotal)
        : 0;

    return fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        reference: reference,
        cart_token: cart.token,
        currency: (cart.currency || "BBD").toUpperCase(),
        total: total,
        items: mapCartItems(cart),
        shipping: shipping,
      }),
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (data) {
          if (!res.ok) throw new Error(formatApiError(data, res.status));
          return data;
        });
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    // Re-check clock so a slot that passed while filling the form is blocked.
    refreshPickupAvailability();

    if (!validateForm()) {
      showAlert("Please fix the errors below before continuing.");
      return;
    }

    var data = getFormData();
    var phoneCheck = validatePhone(data.phone);
    if (!phoneCheck.valid) {
      setFieldError("phone", phoneCheck.message);
      showAlert("Please enter a valid phone number before continuing.");
      return;
    }
    data.phone = phoneCheck.normalized;

    submitBtn.disabled = true;
    submitBtn.textContent = "Saving…";

    var reference = generateReference();
    var attributes = buildCartAttributes(data, reference);
    var continueLabel = form.dataset.continueLabel || "Continue to Payment";

    getCart()
      .then(function (cart) {
        if (!cart.item_count) {
          throw new Error("Your cart is empty. Add products before checkout.");
        }
        return updateCartAttributes(attributes).then(function () {
          return { cart: cart, shipping: data };
        });
      })
      .then(function (payload) {
        submitBtn.textContent = "Redirecting to payment…";
        return createPayment(payload.cart, payload.shipping, reference);
      })
      .then(function (result) {
        if (!result || !result.payment_url) {
          throw new Error("Payment URL was not returned by the server.");
        }
        window.location.assign(result.payment_url);
      })
      .catch(function (err) {
        console.error("[juici-shipping]", err);
        showAlert(err.message || "Something went wrong. Please try again.");
        submitBtn.disabled = false;
        submitBtn.textContent = continueLabel;
      });
  });

  form.querySelectorAll("input, select").forEach(function (el) {
    el.addEventListener("input", function () {
      if (fields[el.name]) {
        var error = validateField(el.name);
        setFieldError(el.name, error);
        if (!error) hideAlert();
      }
      if (el.name === "pickup_time" || el.name === "pickup_date") {
        updateSummaryPickup();
      }
      if (el.name === "accept_terms") {
        setFieldError("accept_terms", "");
      }
    });

    el.addEventListener("change", function () {
      if (fields[el.name]) {
        setFieldError(el.name, validateField(el.name));
      }
    });

    el.addEventListener("blur", function () {
      if (fields[el.name]) {
        setFieldError(el.name, validateField(el.name));
      }
    });
  });

  form.querySelectorAll('input[name="fulfillment_type"]').forEach(function (el) {
    el.addEventListener("change", function () {
      setFieldError("fulfillment_type", "");
      syncFulfillmentUI();
    });
  });

  if (pickupDateSelect) {
    pickupDateSelect.addEventListener("change", function () {
      setFieldError("pickup_date", "");
      buildPickupSlots();
      updateSummaryPickup();
    });
  }

  if (pickupSelect) {
    pickupSelect.addEventListener("change", function () {
      setFieldError("pickup_time", "");
      updateSummaryPickup();
    });
  }

  buildPickupDates();
  buildPickupSlots();
  syncFulfillmentUI();

  // Keep "passed" slots in sync while the customer fills the form.
  var refreshMs = 30000;
  setInterval(refreshPickupAvailability, refreshMs);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") refreshPickupAvailability();
  });
  window.addEventListener("focus", refreshPickupAvailability);
})();
